/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// @mui material components
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import TableContainer from '@mui/material/TableContainer';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// Material Dashboard 2 PRO React examples
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';

import RoleMenuUser from './RoleMenuUser';

function RoleMenu() {
  const mod = 'role';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [record, setRecord] = useState([]);
  const [loading, setLoading] = useState(true);

  const view = () => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/listmenu`, app.token, {
      lang: app.lang,
      ref_id: id,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);
      }
      setLoading(false);
    });
  };

  const renderList = () => {
    return (
      <MDBox className='card'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TableContainer sx={{ boxShadow: 0, minHeight: 500 }}>
              <Table aria-label='simple table'>
                <TableBody>
                  {record.map((row, i) => (
                    <TableRow key={row.id}>
                      <TableCell width={120}>
                        <MDTypography variant='body2'>{row.name}</MDTypography>
                      </TableCell>
                      <TableCell>
                        {row.sub.map((item) => (
                          <RoleMenuUser parent={item} key={item.id} />
                        ))}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    view();
  }, [id]);

  return (
    <div>
      {renderList()}
      {renderLoading()}
    </div>
  );
}

export default RoleMenu;
